// extracted by mini-css-extract-plugin
export default {"picklist":"picklist_picklist__gjLwG"};